import actionTypes from '../actions/actionTypes';
import { VOICE_CALL_STATUS_TEXT } from '../../../constants';

const INITIAL_STATE = {
  capabilityToken: {},
  isMinimized: false,
  hasCallInProgress: false,
  callStatus: VOICE_CALL_STATUS_TEXT.DISCONNECT,
  loadingClientData: false,
};

export const voiceCall = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.DO_VOICE_CALL:
      return {
        ...state,
      };
    case actionTypes.DO_VOICE_CALL_SUCCESS:
      return {
        ...state,
        capabilityToken: payload,
      };
    case actionTypes.DO_VOICE_CALL_ERROR:
      return {
        ...state,
        error: payload,
      };
    case actionTypes.SET_VOICE_CALL_DATA:
      return {
        ...state,
        initiationData: payload,
        loadingClientData: false,
      };
    case actionTypes.VOICE_CALL_CLIENT_DATA_LOADING:
      return {
        ...state,
        loadingClientData: true,
      };
    case actionTypes.SET_CALL_STATUS:
      return {
        ...state,
        callStatus: payload,
      };

    case actionTypes.SET_CALL_MINIMIZE:
      return {
        ...state,
        isMinimized: payload,
      };

    case actionTypes.SET_CALL_IN_PROGRESS:
      return {
        ...state,
        hasCallInProgress: payload,
      };

    default:
      return state;
  }
};

export default voiceCall;
